import { render, staticRenderFns } from "./SaleSummary.vue?vue&type=template&id=3a93b452"
import script from "./SaleSummary.vue?vue&type=script&lang=js"
export * from "./SaleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports